

























































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { PriceResponse } from '@a/store/price/types';

@Component
export default class CheckoutPrice extends Vue {
  @Prop({ type: Boolean, required: false }) readonly locationCheck!: boolean;

  @Prop({ type: Boolean, required: true }) readonly disablePayment!: boolean;

  @Prop({ type: Boolean, required: true }) readonly isVatRequired!: boolean;

  @Prop({ type: Boolean, required: true }) readonly switchRegion!: boolean;

  @Getter('price/price') readonly pricing!: PriceResponse;

  get isPriceDiscounted(): boolean {
    return this.pricing.price.final_price.amount > this.pricing.price.discounted_price.amount;
  }

  onOrderSubmit(event: Event): void {
    this.$emit('on-order-submit', event);
  }
}
